<template>
  <el-dialog
    v-model="localVisible"
    title="주문취소"
    width="520px"
    :close-on-click-modal="false"
    align-center
    @close="emitClose"
  >
    <div class="cancel-modal-body">
      <el-form :model="form" label-position="top">
        <el-form-item label="취소 사유">
          <el-select v-model="form.code" placeholder="취소 사유를 선택하세요" style="width: 100%;">
            <el-option
              v-for="reason in cancelReasons"
              :key="reason.value"
              :label="reason.label"
              :value="reason.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="상세 사유">
          <el-input
            v-model="form.cancelDetailedReason"
            type="textarea"
            :rows="4"
            maxlength="200"
            show-word-limit
            placeholder="필요하면 상세 사유를 입력하세요"
          />
        </el-form-item>
      </el-form>
    </div>

    <template #footer>
      <span class="dialog-footer">
        <el-button :disabled="submitting" @click="emitClose">닫기</el-button>
        <el-button type="danger" :loading="submitting" :disabled="submitting" @click="emitSubmit">
          주문취소
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { computed, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';

const CANCEL_REASONS = [
  { value: 'INTENT_CHANGED', label: '구매 의사 취소' },
  { value: 'COLOR_AND_SIZE', label: '색상 및 사이즈 변경' },
  { value: 'WRONG_ORDER', label: '다른 상품 잘못 주문' },
  { value: 'PRODUCT_UNSATISFIED', label: '서비스 불만족' },
  { value: 'DELAYED_DELIVERY', label: '배송 지연' },
  { value: 'SOLD_OUT', label: '상품 품절' },
  { value: 'INCORRECT_INFO', label: '상품 정보 상이' },
];

const createDefaultForm = () => ({
  code: 'INTENT_CHANGED',
  cancelDetailedReason: '',
});

export default {
  name: 'OrderCancelModal',
  props: {
    visible: { type: Boolean, default: false },
    order: { type: Object, default: () => null },
    submitting: { type: Boolean, default: false },
  },
  emits: ['close', 'submit'],
  setup(props, { emit }) {
    const localVisible = ref(props.visible);
    const form = ref(createDefaultForm());

    const productOrderIds = computed(() => (
      Array.isArray(props.order?.productOrderIds) ? props.order.productOrderIds : []
    ));

    const resetForm = () => {
      form.value = createDefaultForm();
    };

    const emitClose = () => {
      emit('close');
    };

    const emitSubmit = () => {
      if (!props.order) {
        ElMessage.warning('취소할 주문이 없습니다.');
        return;
      }
      if (!form.value.code) {
        ElMessage.warning('취소 사유를 선택해주세요.');
        return;
      }
      if (productOrderIds.value.length === 0) {
        ElMessage.warning('취소할 주문번호가 없습니다.');
        return;
      }

      emit('submit', {
        code: form.value.code,
        cancelDetailedReason: String(form.value.cancelDetailedReason || '').trim() || null,
      });
    };

    watch(() => props.visible, (visible) => {
      localVisible.value = visible;
      if (visible) resetForm();
    });

    return {
      localVisible,
      form,
      cancelReasons: CANCEL_REASONS,
      emitClose,
      emitSubmit,
    };
  },
};
</script>

<style scoped>
.cancel-modal-body {
  display: grid;
  gap: 8px;
}
</style>
